function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { Global } from '@emotion/react';
import * as styles from './allhomes-search-more-options.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class AllhomesSearchMoreOptions extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "renderComponents", () => React.Children.toArray(this.props.children).map(child => /*#__PURE__*/React.cloneElement(child, {
      onChange: this.props.onChange,
      onReset: this.onReset,
      embedded: this.props.embedded
    })));
  }
  render() {
    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Global, {
      styles: styles.global
    }), ___EmotionJSX("section", {
      css: styles.wrapper
    }, ___EmotionJSX("div", null, this.renderComponents())));
  }
}
AllhomesSearchMoreOptions.propTypes = {
  onChange: PropTypes.func,
  embedded: PropTypes.bool,
  children: PropTypes.node.isRequired
};
AllhomesSearchMoreOptions.defaultProps = {
  embedded: false,
  onChange: () => {}
};
export default AllhomesSearchMoreOptions;